import React, {useContext} from 'react';

import {assertNotNullAndReturn} from 'Asserts';

import {
  SidepanelChange,
  SidepanelInternalState,
  SidepanelRegisterTabState,
} from './useFlowchartSidepanelManager';

export interface FlowchartSidepanelManagerContextValue {
  registerTab: (params: SidepanelRegisterTabState) => void;
  unregisterTab: (tab: string) => void;
  setIsTabDirty: (tab: string, isDirty: boolean) => void;
  changeSidepanel: (sidepanelChange: SidepanelChange) => Promise<boolean>;
  changeTab: (newTab: string, activeTab: string) => Promise<boolean>;
  forceClose: () => void;
  getEffectiveState: () => SidepanelInternalState;
}

export const FlowchartSidepanelManagerContext =
  React.createContext<FlowchartSidepanelManagerContextValue | null>(null);

/**
 * Note that this accessor should only be used when you know the context provider exists, as
 * it will throw if one is not found!
 */
export function useFlowchartSidepanelManagerContext(): FlowchartSidepanelManagerContextValue {
  return assertNotNullAndReturn(useContext(FlowchartSidepanelManagerContext));
}
